module.exports = "pegasus_template/assets/themecapture1/travel/109.png";